import { AbstractIntProperty } from './AbstractIntProperty'

export class PropertyId extends AbstractIntProperty {
  KEY: string = 'propertyId'
}
